import script from "./BComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BComponent.vue?vue&type=script&setup=true&lang=js"

import "./BComponent.vue?vue&type=style&index=0&id=2a7e8061&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7e8061"]])

export default __exports__